import ancestor from "./ancestor";

export default () => {

    const holders = document.querySelectorAll('[data-qty-field]');
    const priceSpans = document.querySelectorAll('[data-price-display]');


    function updatePricing(qty, list) {
        let price = '';
        for (const item of list) {
            if (qty >= item.qty) {
                price = item.rate;
            }
        }
        for (const priceSpan of priceSpans) {
            priceSpan.innerHTML = price;
        }
    }

    for (const holder of holders) {

        const form = ancestor(holder, 'form');
        const upButton = holder.querySelector('[data-up]');
        const downButton = holder.querySelector('[data-down]');
        const input = holder.querySelector('input');
        const pricingData = JSON.parse(form.getAttribute('data-pricelist'));

        upButton.addEventListener('click', (e) => {
            e.preventDefault();
            let val = parseInt(input.value);
            val += 1;
            input.value = val;
            updatePricing(val, pricingData);
            return false;
        });

        downButton.addEventListener('click', (e) => {
            e.preventDefault();
            let val = parseInt(input.value);
            val -= 1;
            if (val < 0) {
                val = 0;
            }
            input.value = val;
            updatePricing(val, pricingData);
            return false;
        })

    }

}
